import React from 'react'

export default function Landing() {
  return (
        <div className="container">
             <div class="row align-items-center py-5">
            <div class="col-lg-6 py-5 text-center text-md-start">
                <h1 class="h1" style={{fontWeight:"700"}}>Courage Bernard</h1>
                <p className='grey-text'>Fullstack Developer | Designer | Business Enthusiast</p>
                <p className='grey-text'>Have something to say? <a target='_blank' rel="noreferrer" href='https://forms.gle/93JT3g19gJpCufYL6'>Let's talk <i class="bi bi-arrow-right-circle"></i></a></p>
                    
            </div>
            
            <div class="col-lg-6 text-center pt-5 pt-lg-2">
                <img class="img-fluid" src="./img/Hand coding-pana.png" alt="Developer" />
            </div>
        </div>
        </div>
       
    
    
       

  )
}
